<template>
  <div class="product-card" @click="openModal">
    <div class="product-card-label">
      <div
        v-if="productData.productIsCapsula"
        class="product-card-label-circle product-card-label-capsule"
        :class="`flavor-${productData.flavor}`"
        :style="bgStyle"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.843 5.53971C5.72422 6.72438 4.96234 8.23372 4.65369 9.87687C4.34504 11.52 4.50349 13.2232 5.10901 14.771C5.71452 16.3188 6.7399 17.6417 8.05548 18.5725C9.37107 19.5032 10.9178 20 12.5 20C14.0822 20 15.6289 19.5032 16.9445 18.5725C18.2601 17.6417 19.2855 16.3188 19.891 14.771C20.4965 13.2232 20.655 11.52 20.3463 9.87687C20.0377 8.23372 19.2758 6.72438 18.157 5.53971M12.5 7.29421V2" stroke="currentColor" stroke-linecap="round"/>
        </svg>
      </div>

      <div
        v-if="productData.productFlavorName"
        class="product-card-label-flavor"
        :class="`flavor-${productData.flavor}`"
      >
        <div class="product-card-label-circle product-card-label-flavor__img">
          <TasteIcon :name="productData.flavor" />
        </div>
        <div class="product-card-label-flavor__name">{{ productData.productFlavorName }}</div>
      </div>
    </div>

    <figure class="product-card__figure" tabindex="-1">
      <img
        :src="productData.imgSrc"
        :alt="productData.imgAlt"
        width="125"
        height="145"
      >
    </figure>

    <p
      class="product-card__title"
      :id="productTitleId"
    >
      {{ productData.productTitle }}
    </p>

    <div class="product-card__bottom">
      <div class="product-card__price">{{ productData.priceText }}</div>

      <div class="product-card__add">
        <button
          ref="addButtonEl"
          type="button"
          class="btn-add"
          :class="{
            'is-active': qty > 0,
            'is-disabled': isAddDisabled
          }"
          :aria-disabled="isAddDisabled"
          :aria-describedby="(isAddDisabled && isTipVisible) ? addTipId : null"
          :aria-labelledby="`${addActionId} ${productTitleId}`"
          @click.stop="onAddClick"
          @blur="onAddBlur"
          @keydown.esc.stop.prevent="onAddEscape"
        >
          <span
            :id="addActionId"
            class="visually-hidden"
          >
            {{ t('addBlock') }}
          </span>

          <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M8.03528 15.5342C9.00443 15.5342 9.79297 16.3229 9.79309 17.292C9.79309 18.2612 9.00451 19.0498 8.03528 19.0498C7.06615 19.0497 6.27747 18.2611 6.27747 17.292C6.27759 16.3229 7.06623 15.5343 8.03528 15.5342ZM14.0948 15.5342C15.0638 15.5344 15.8516 16.323 15.8517 17.292C15.8517 18.2611 15.0639 19.0496 14.0948 19.0498C13.1256 19.0498 12.337 18.2612 12.337 17.292C12.3372 16.3229 13.1257 15.5342 14.0948 15.5342ZM8.03528 16.4463C7.56911 16.4464 7.1897 16.8258 7.18958 17.292C7.18958 17.7583 7.56903 18.1376 8.03528 18.1377C8.50162 18.1377 8.88098 17.7583 8.88098 17.292C8.88086 16.8258 8.50154 16.4463 8.03528 16.4463ZM14.0948 16.4463C13.6286 16.4463 13.2483 16.8258 13.2482 17.292C13.2482 17.7583 13.6285 18.1377 14.0948 18.1377C14.561 18.1374 14.9406 17.7582 14.9406 17.292C14.9404 16.8259 14.5609 16.4465 14.0948 16.4463ZM0.223755 0.142578C0.423454 -0.0107189 0.710112 0.0268386 0.863403 0.226562L2.87512 2.84766C2.91038 2.89369 2.93661 2.94614 2.95227 3.00195L3.75012 5.85645H18.6896C18.832 5.85648 18.9667 5.92272 19.0529 6.03613C19.1391 6.14959 19.1672 6.29726 19.129 6.43457L16.8566 14.5996C16.8017 14.7969 16.6218 14.9336 16.4171 14.9336H5.67883C5.47412 14.9336 5.29427 14.7969 5.23938 14.5996L2.0968 3.33203L0.139771 0.782227C-0.013503 0.582526 0.0240689 0.295884 0.223755 0.142578ZM5.76965 13.0762C5.77703 13.1026 5.78079 13.1291 5.78333 13.1553L6.02551 14.0215H16.0704L18.09 6.76855H4.00598L5.76965 13.0762ZM15.1105 11.0723C15.362 11.0725 15.5663 11.2758 15.5665 11.5273C15.5665 11.779 15.3621 11.9832 15.1105 11.9834H7.19446C6.94282 11.9832 6.73938 11.779 6.73938 11.5273C6.73962 11.2759 6.94297 11.0725 7.19446 11.0723H15.1105ZM15.3966 8.73633C15.6482 8.73659 15.8517 8.94073 15.8517 9.19238C15.8516 9.44397 15.6482 9.64818 15.3966 9.64844H6.90833C6.65678 9.64818 6.45332 9.44397 6.45325 9.19238C6.45325 8.94073 6.65673 8.73659 6.90833 8.73633H15.3966Z" fill="currentColor" stroke="currentColor" stroke-width="0.0909091"/>
          </svg>

          <span v-if="qty > 0" class="btn-add__badge">{{ qty }}</span>
        </button>
      </div>

      <div
        v-if="isSubscriptionLimitReached && isTipVisible"
        ref="addTipEl"
        class="btn-add-tooltip"
        :id="addTipId"
        role="tooltip"
        v-html="t('tooltipRepeat')"
      ></div>

      <div
        v-else-if="isGlobalLimitReached && isTipVisible"
        ref="addTipEl"
        class="btn-add-tooltip"
        :id="addTipId"
        role="tooltip"
        v-html="t('tooltipMany')"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, onBeforeUnmount, onMounted, ref } from 'vue'
import TasteIcon from './TasteIcon.vue'

const i18n = {
  uk: {
    addBlock: 'Додати блок',
    tooltipMany: 'В послузі може бути не більше <span>5 блоків стіків</span>',
    tooltipRepeat:'Ці стіки вже додані до підписки. Їх можна лише видалити АБО додати повторно за оновленою ціною',
  },
  ru: {
    addBlock: 'Добавить блок',
    tooltipMany: 'В услуге может быть не более <span>5 блоков стиков</span>',
    tooltipRepeat: 'Эти стики уже добавлены в подписку. Их можно только удалить ИЛИ добавить заново по обновленной цене'
  }
}

const locale = computed(() => window.Shopify?.locale || 'uk')
const t = (key) => i18n[locale.value]?.[key] || key

const props = defineProps({
  product: { type: Object, required: true },
  qty: { type: Number, default: 0 },
  subscriptionQty: { type: Number, default: 0 },
  canAddMore: { type: Boolean, default: true },
  currencyLabel: { type: String, default: 'грн' },
  activeTipKey: { type: [String, Number, null], default: null },
})

const emit = defineEmits(['add', 'openProductModal', 'cant-add', 'dismiss-tip'])
const componentUid = getCurrentInstance()?.uid ?? 'x'
const addButtonEl = ref(null)
const addTipEl = ref(null)

const productData = computed(() => {
  const product = props.product ?? {}

  return {
    imgSrc: product.images?.[0] ?? '',
    imgAlt: product.image_alt ?? product.alt ?? '',
    productTitle: product.product_title ?? '',
    priceText: product.product_price != null
      ? `${product.product_price} ${props.currencyLabel}`
      : '',
    productIsCapsula: !!product.capsule,
    productFlavorName: product.flavor_name ?? '',
    flavor: product.flavor ?? '',
  }
})

const defaultGradient =
  'radial-gradient(119.33% 119.33% at 76% 100%, #5A1B25 5%, #A2132A 95%)'

const bgStyle = computed(() => ({
  '--bg-color': props.product?.icons_color?.trim()
    ? props.product.icons_color
    : defaultGradient,
}))

const normalizeIdPart = (value) => String(value ?? 'x')
  .trim()
  .replace(/[^\p{L}\p{N}_-]+/gu, '-')
  .replace(/^-+|-+$/g, '') || 'x'

const tipKey = computed(() => (
  props.product?.product_id ?? props.product?.id ?? productData.value.productTitle ?? 'x'
))
const addTipId = computed(() => `add-tooltip-${tipKey.value}`)
const productCardId = computed(() => (
  `subscription-product-${normalizeIdPart(tipKey.value)}-${componentUid}`
))
const productTitleId = computed(() => `${productCardId.value}-title`)
const addActionId = computed(() => `${productCardId.value}-add-action`)

const isSubscriptionLimitReached = computed(() => {
  return props.subscriptionQty > 0 && props.qty >= props.subscriptionQty
})

const isGlobalLimitReached = computed(() => {
  return !props.canAddMore
})

const isAddDisabled = computed(() => {
  return isSubscriptionLimitReached.value || isGlobalLimitReached.value
})

const isTipVisible = computed(() => props.activeTipKey === tipKey.value)

const onAddClick = () => {
  if (isAddDisabled.value) {
    emit('cant-add', tipKey.value)
    return
  }

  emit('add', props.product)
}

const dismissTip = () => {
  if (isTipVisible.value) emit('dismiss-tip', tipKey.value)
}

const containsTarget = (el, target) => {
  return !!el && target instanceof Node && (el === target || el.contains(target))
}

const onDocumentPointerDown = (event) => {
  if (!isTipVisible.value) return

  const target = event.target
  if (
    containsTarget(addButtonEl.value, target) ||
    containsTarget(addTipEl.value, target)
  ) {
    return
  }

  dismissTip()
}

const onAddBlur = () => {
  dismissTip()
}

const onAddEscape = () => {
  dismissTip()
}

function openModal() {
  emit('openProductModal', props.product)
}

onMounted(() => {
  document.addEventListener('pointerdown', onDocumentPointerDown, true)
})

onBeforeUnmount(() => {
  document.removeEventListener('pointerdown', onDocumentPointerDown, true)
})
</script>
